export default __webpack_public_path__ + "static/media/game-pagetype-results_loose_game.8597651f.svg";